import request from '../request';
// 判断金牌医生入口是否显示
const getGoldDorRightControl = () => {
  return request.post('/api/wx/auth/getGoldDorRightControl')
}
// 根据科室查医生列表
const getLevel1DepartmentList = (data) => {
  return request.post('/api/wx/auth/getLevel1DepartmentList', data)
}
// 根据地区查医生列表
const getGoldDorDistrictList = (data) => {
  return request.post('/api/wx/auth/getGoldDorDistrictList', data)
}
// 查询全部医生
const getAllPhysicianList = (data) => {
  return request.post(`/api/wx/auth/getAllPhysicianList`, data)
}
// 查询医生职称
const getProviderDirPhyisicanTitle = () => {
  return request.post('/api/wx/auth/getProviderDirPhyisicanTitle')
}
// 保存预约
const saveGoldAppointment = (data) => {
  return request.post('/api/wx/auth/saveGoldAppointment', data)
}
// 获取预约列表
const getGoldAppointmentList = (data) => {
  return request.post(`/api/wx/auth/getGoldAppointmentList?language=${data.language}`, data)
}
// 预约详情
const goldAppointmentDetail = (data) => {
  return request.post(`/api/wx/auth/goldAppointmentDetail?queryno=${data.queryno}&language=${data.language}`, data)
}
// 取消预约
const goldAppointmentCancel = (data) => {
  return request.post(`/api/wx/auth/goldAppointmentCancel?queryno=${data.queryno}`, data)
}
// 对象数组
export default {
    getGoldDorRightControl,
    getLevel1DepartmentList,
    getGoldDorDistrictList,
    getAllPhysicianList,
    getProviderDirPhyisicanTitle,
    saveGoldAppointment,
    getGoldAppointmentList,
    goldAppointmentDetail,
    goldAppointmentCancel
};